import { Component } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-import-orders-approved',
  templateUrl: './user-import-orders-approved.component.html',
  styleUrls: ['./user-import-orders-approved.component.css'],
  providers: [ConfirmationService]
})
export class UserImportOrdersApprovedComponent {
}
